import LoginPage from "./pages/selfcare/LoginPage";
import AddLoginPage from "./pages/selfcare/AddLoginPage";
import {default as InvoiceOverviewPage} from "./pages/selfcare/invoice/OverviewPage";
import CardPage from "./pages/selfcare/card/CardPage";
import AccountPage from "./pages/selfcare/AccountPage";
import SelfcareLayout from "./layouts/SelfcareLayout";
import ChangeCardPage, {ChangeCardErrorPage, ChangeCardSuccessPage} from "./pages/selfcare/card/ChangeCardPage";
import ShowPage from "./pages/selfcare/communication/ShowPage";
import {default as CommunicationOverviewPage} from "./pages/selfcare/communication/OverviewPage";
import CreatePasswordPage from "./pages/selfcare/CreatePasswordPage";
import SbbuPage from "./pages/selfcare/sbbu/SbbuPage";
import SbbuReceiptPage from "./pages/selfcare/sbbu/SbbuReceiptPage";
import ErrorRoute from "./util/ErrorRoute";
import NotFoundPage from "./pages/selfcare/NotFoundPage"
import OverviewPage from "./pages/selfcare/OverviewPage";
import InternetPage from "./pages/selfcare/InternetPage";
import NextInvoicePage from "./pages/selfcare/invoice/NextInvoicePage";
import PayInvoicePage from "./pages/selfcare/invoice/PayInvoicePage";
import HelpHomePage from "./pages/help/HelpHomePage.tsx";
import HelpCategoryPage from "./pages/help/HelpCategoryPage.tsx";
import HelpArticlePage from "./pages/help/HelpArticlePage.tsx";
import HelpLayout from "./layouts/HelpLayout.tsx";
import AboutPage from "./pages/about/AboutPage.tsx";
import TrustpilotPage from "./pages/about/TrustpilotPage.tsx";
import JobsPage from "./pages/about/JobsPage.tsx";
import ConditionsPage from "./pages/about/ConditionsPage.tsx";
import PressPage from "./pages/press/PressPage.tsx";
import CustomerSatisfactionPage from "./pages/about/CustomerSatisfactionPage.tsx";
import PressReleasePage from "./pages/press/releases/PressReleasePage.tsx";
import ContactIndexPage from "./pages/contact/ContactIndexPage.tsx";
import ContactFormPage from "./pages/contact/ContactFormPage.tsx";
import ContactInternetNotWorking from "./pages/contact/ContactInternetNotWorking.tsx";
import ContactUnstablePage from "./pages/contact/ContactUnstablePage.tsx";
import ContactSetupPage from "./pages/contact/ContactSetupPage.tsx";
import ContactReturnPage from "./pages/contact/ContactReturnPage.tsx";
import ContactInvoicePage from "./pages/contact/ContactInvoicePage.tsx";
import ContactAccountPage from "./pages/contact/ContactAccountPage.tsx";
import ContactDeliveryTime from "./pages/contact/ContactDeliveryTime.tsx";
import ContactOrderPage from "./pages/contact/ContactOrderPage.tsx";
import OrderIndexPage from "./pages/order/OrderIndexPage.tsx";
import DaekningskortPage from "./pages/broadband/DaekningskortPage.tsx";
import CoaxPage from "./pages/broadband/CoaxPage.tsx";
import FiberPage from "./pages/broadband/FiberPage.tsx";
import TDC5GPage from "./pages/broadband/TDC5GPage.tsx";
import WifiMeshPage from "./pages/broadband/WifiMeshPage.tsx";
import MobileBroadbandPage from "./pages/broadband/MobileBroadbandPage.tsx";
import BroadbandIndexPage from "./pages/broadband/BroadbandIndexPage.tsx";
import Routing from "./Routing.ts";
import IndexPage from "./pages/IndexPage.tsx";
import TilbudPage from "./pages/alternative-frontpages/TilbudPage.tsx";
import FibiaPage from "./pages/alternative-frontpages/FibiaPage.tsx";
import FibiaFiberPage from "./pages/alternative-frontpages/FibiaFiberPage.tsx";
import IdaPage from "./pages/alternative-frontpages/IdaPage.tsx";
import TjekBredbaandPage from "./pages/alternative-frontpages/TjekBredbaandPage.tsx";
import TDCPaidPage from "./pages/alternative-frontpages/TDCPaidPage.tsx";
import LargeAccountOrderPage from "./pages/order/LargeAccountOrderPage.tsx";
import QueryParamRedirector from "./components/redirect/QueryParamRedirector.tsx";

const routes = [
    {
        path: Routing.Index,
        element: <QueryParamRedirector><IndexPage/></QueryParamRedirector>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.AlternativeFrontPages.Tilbud,
        element: <TilbudPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.AlternativeFrontPages.Fibia,
        element: <FibiaPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.AlternativeFrontPages.FibiaFiber,
        element: <FibiaFiberPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.AlternativeFrontPages.Ida,
        element: <IdaPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.AlternativeFrontPages.TjekBredbaand,
        element: <TjekBredbaandPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.AlternativeFrontPages.TDCPaid,
        element: <TDCPaidPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Order,
        element: <OrderIndexPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: "/bestil/storkunde/:customer_id",
        element: <LargeAccountOrderPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Broadband.Index,
        element: <BroadbandIndexPage />,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Broadband.CoverageMap,
        element: <DaekningskortPage />,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Broadband.Coax,
        element: <CoaxPage />,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Broadband.Fiber,
        element: <FiberPage />,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Broadband.TDC5G,
        element: <TDC5GPage />,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Broadband.MBB,
        element: <MobileBroadbandPage />,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Broadband.Mesh,
        element: <WifiMeshPage />,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.About.Index,
        element: <AboutPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.About.Trustpilot,
        element: <TrustpilotPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.About.Jobs,
        element: <JobsPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.About.Conditions,
        element: <ConditionsPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.About.CustomerSatisfaction,
        element: <CustomerSatisfactionPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.About.Press,
        element: <PressPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.About.Press + "/:release_query",
        element: <PressReleasePage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Help.Index,
        element: <HelpLayout/>,
        errorElement: <p>Noget gik galt</p>,
        children: [
            {
                path: Routing.Help.Index,
                element: <HelpHomePage/>,
            },
            {
                path: "/hjaelp/:category_query",
                element: <HelpCategoryPage/>,
            },
            {
                path: "/hjaelp/:category_query/:article_query",
                element: <HelpArticlePage/>,
            },
        ]
    },
    {
        path: Routing.Contact.Index,
        element: <ContactIndexPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Contact.Form,
        element: <ContactFormPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Contact.InternetNotWorking,
        element: <ContactInternetNotWorking/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Contact.InternetUnstable,
        element: <ContactUnstablePage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Contact.RouterSetup,
        element: <ContactSetupPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Contact.EquipmentReturn,
        element: <ContactReturnPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Contact.BillAndPaymentCard,
        element: <ContactInvoicePage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Contact.Subscription,
        element: <ContactAccountPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Contact.DeliveryTime,
        element: <ContactDeliveryTime/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Contact.Order,
        element: <ContactOrderPage/>,
        errorElement: <p>Noget gik galt</p>,
    },
    {
        path: Routing.Selfcare.Login,
        element: <LoginPage/>,
        errorElement: <ErrorRoute/>,
    },
    {
        path: Routing.Selfcare.LoginCreate,
        element: <AddLoginPage/>,
        errorElement: <ErrorRoute/>,
    },
    {
        path: Routing.Selfcare.LoginCode,
        element: <CreatePasswordPage/>,
        errorElement: <ErrorRoute/>,
    },
    {
        path: Routing.Selfcare.Index,
        element: <SelfcareLayout/>,
        errorElement: <ErrorRoute/>,
        children: [
            {
                path: Routing.Selfcare.Index,
                element: <OverviewPage/>,
            },
            {
                path: Routing.Selfcare.Internet,
                element: <InternetPage/>,
            },
            {
                path: Routing.Selfcare.Bills,
                element: <InvoiceOverviewPage/>,
            },
            {
                path: Routing.Selfcare.NextBill,
                element: <NextInvoicePage/>,
            },
            {
                path: Routing.Selfcare.PayBill,
                element: <PayInvoicePage/>,
            },
            {
                path: Routing.Selfcare.Account,
                element: <AccountPage/>,
            },
            {
                path: Routing.Selfcare.Letters,
                element: <CommunicationOverviewPage/>,
            },
            {
                path: Routing.Selfcare.Letters + "/vis/:request_id",
                element: <ShowPage/>,
            },
            {
                path: Routing.Selfcare.Card,
                element: <CardPage/>,
            },
            {
                path: Routing.Selfcare.AddCard,
                element: <ChangeCardPage/>,
            },
            {
                path: Routing.Selfcare.AddCard + "/succes/:customer_id/:quickpay_order_id",
                element: <ChangeCardSuccessPage/>,
            },
            {
                path: Routing.Selfcare.AddCard + "/fejl/:customer_id/:quickpay_order_id",
                element: <ChangeCardErrorPage/>,
            },
            {
                path: Routing.Selfcare.TerminateExisting,
                element: <SbbuPage/>,
            },
            {
                path: Routing.Selfcare.TerminateExistingReceipt,
                element: <SbbuReceiptPage/>,
            },
        ],
    },
    {
        path: '*',
        element: <NotFoundPage/>
    }
]

export default routes
